export const propAdapter = map => value => {
  const themeValue = map[value];
  return themeValue !== undefined ? "var(".concat(themeValue, ")") : value;
};